export const HEADER_TYPES = {
  CONTACTS: 'contacts',
  EMAIL: 'email',
  SMS: 'sms',
}

export const PLAN_TYPES = {
  FREE: 1,
  STANDARD: 2,
  CUSTOM: 3,
  CORPORATE: 4,
  PAY_AS_YOU_GO: 5
}

export const PLAN_FEATURES = {
  free: {
    available: [
      { id: 1, featureName: 'planSubscriptions.free.platformUsers' },
      { id: 2, featureName: 'planSubscriptions.free.emailsPerMonth' },
      { id: 3, featureName: 'planSubscriptions.free.campaignTemplates' },
      { id: 4, featureName: 'planSubscriptions.free.chatEmailSupport' },
      { id: 5, featureName: 'planSubscriptions.free.htmlTemplateImport' },
    ],
    notAvailable: [{ id: 6, featureName: 'planSubscriptions.free.premiumTemplates' }],
  },
  starter: {
    available: [
      { id: 1, featureName: 'planSubscriptions.starter.platformUsers' },
      { id: 2, featureName: 'planSubscriptions.starter.emailsPerMonth' },
      { id: 3, featureName: 'planSubscriptions.starter.campaignTemplates' },
      { id: 4, featureName: 'planSubscriptions.starter.chatEmailSupport' },
      { id: 5, featureName: 'planSubscriptions.starter.htmlTemplateImport' },
    ],
    notAvailable: [{ id: 6, featureName: 'planSubscriptions.starter.premiumTemplates' }],
  },
  professional: {
    available: [
      { id: 1, featureName: 'planSubscriptions.professional.platformUsers' },
      { id: 2, featureName: 'planSubscriptions.professional.emailsPerMonth' },
      { id: 3, featureName: 'planSubscriptions.professional.campaignTemplates' },
      { id: 4, featureName: 'planSubscriptions.professional.chatEmailSupport' },
      { id: 5, featureName: 'planSubscriptions.professional.htmlTemplateImport' },
      { id: 6, featureName: 'planSubscriptions.professional.premiumTemplates' },
    ],
    notAvailable: [],
  },
  corporate: {
    available: [{ id: 1, featureName: 'planSubscriptions.corporate.consultContract' }],
    notAvailable: [],
  },
  payAsYouGo: {
    available: [
      { id: 1, featureName: 'planSubscriptions.payAsYouGo.platformUsers' },
      { id: 2, featureName: 'planSubscriptions.payAsYouGo.maxContacts' },
      { id: 4, featureName: 'planSubscriptions.payAsYouGo.smsCount' },
      { id: 5, featureName: 'planSubscriptions.payAsYouGo.emailCount' },
      { id: 6, featureName: 'planSubscriptions.payAsYouGo.campaignTemplates' },
      { id: 7, featureName: 'planSubscriptions.payAsYouGo.chatEmailSupport' },
      { id: 8, featureName: 'planSubscriptions.payAsYouGo.htmlTemplateImport' },
      { id: 9, featureName: 'planSubscriptions.payAsYouGo.standardTemplates' },
    ],
    notAvailable: [{ id: 5, featureName: 'planSubscriptions.payAsYouGo.premiumTemplates' },],
  },
}
